module.exports = ".mat-error.outter{\n\tfont-size: 14px;\n\tmargin-top: -8px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/sign-in/sign-in.component.css
// module id = ./src/app/auth/sign-in/sign-in.component.css
// module chunks = main